import { AbstractControl, ValidationErrors } from "@angular/forms";

export class CombinerValidator {

  static notZero(control: AbstractControl): ValidationErrors | null {

    if (! control.value) {
      return null
    }
    if (control.value != "0") {
      return null
    }

    return { combinerSelectionMiss: true }
  }
}
